import $axios from "../../api";

const state = () => ({
  list: [],
  loading: false,
  errors: null,
  page: 1,
  detail: null,
});

const mutations = {
  ASSIGN_LIST(state, payload) {
    state.list = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  ASSIGN_DETAIL(state, payload) {
    state.detail = payload;
  },
};

const actions = {
  fetchList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get("/website/seo/brand/list", {
          params: {
            page: state.page,
            view: rootState.Main.view,
            ...payload,
          },
        })
        .then((response) => {
          commit("ASSIGN_LIST", response.data.data);
          resolve();
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error);

          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  view({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`/website/seo/brand/view`,  {
          params: { id: payload }
        })
        .then((response) => {
          commit("ASSIGN_DETAIL", response.data.data);
          resolve();
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error);

          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  update({ commit }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .put("/website/seo/brand/update", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};